import React, {useState} from 'react';
import {Button, Card, FormLayout, Text,Spinner} from "@shopify/polaris";
import MGSelect from "../../helper/MGSelect";
import {currencyListOptions} from "../../helper/currencyList";

const AppConfiguration = ({formik,saveDataShopifyFn}) => {
    return (
        <>
            <Card>
                <div style={{display:"flex",alignItems:"center", justifyContent:"space-between"}}>
                    <div>
                        <Text fontWeight="bold" as="p" >
                            Application status
                        </Text>
                        <Text as="p">
                            Enable or disable currency converter on your store.
                        </Text>
                    </div>
                    <div>
                        {
                            formik.values.appStatus ? <Button loading={formik.values?.appStatusLoader} onClick={() => {saveDataShopifyFn('appStatusLoader')}} size="large" variant="primary" tone="critical">disable</Button> : <Button loading={formik.values?.appStatusLoader} onClick={() => {saveDataShopifyFn('appStatusLoader')}} size="large" variant="primary" >Enable</Button>
                        }
                    </div>
                </div>
            </Card>
            <br/>
            <Card >
                <Text as="h2" variant="headingSm">
                    Currencies Setting
                </Text>
                <br/>
                <FormLayout>
                    <MGSelect
                        labelName={`My Currencies`}
                        selectValue={formik.values.currenciesList}
                        onChangeFn={(value) => {
                            let currenciesList = value || [];
                            let defaultCurrency = currenciesList.find(currecny => currecny.value === formik.values.storeDefaultCurrency.value);
                            if(!defaultCurrency){
                                currenciesList.push(formik.values.storeDefaultCurrency)
                            }
                            formik.setFieldValue('currenciesList',currenciesList);
                        }}
                        optionsList={currencyListOptions}
                        isMulti={true}
                    />
                    <MGSelect
                        labelName={`My Default Currency(For Rest of The World)`}
                        selectValue={formik.values.defaultCurrency}
                        onChangeFn={(value) => {formik.setFieldValue( 'defaultCurrency', value)}}
                        optionsList={formik.values.currenciesList}
                    />
                </FormLayout>
                <div className="store-integration-message-div" style={{justifyContent:"end"}}>
                    <Button loading={formik.values?.saveLoader} onClick={() => {saveDataShopifyFn('saveLoader')}} size="large" variant="primary">save</Button>
                </div>
            </Card>
            <br/>
        </>
    );
};

export default AppConfiguration;
